import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import AppRoutings from './routings/Index';

function App({showHeader}) {
  useEffect(() => {
    Aos.init({ duration: 200 });
  }, []);

  return <AppRoutings showHeader={showHeader} />;
}

export default App;
